/* eslint-disable */
import React, { useState } from 'react';
import './styles/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    category: 'general',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Thank you for your message. We will get back to you soon!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        category: 'general',
        message: ''
      });
    }, 2000);
  };

  const contactMethods = [
    {
      icon: '📍',
      title: 'Visit Us',
      details: [
        'Ministries Complex Road',
        'Mobil Round About (National Blood Bank)',
        'Juba, South Sudan'
      ],
      description: 'Our main office location'
    },
    {
      icon: '📞',
      title: 'Call Us',
      details: [
        '+211 912 345 678',
        '+211 987 654 321'
      ],
      description: 'Available during business hours'
    },
    {
      icon: '✉️',
      title: 'Email Us',
      details: [
        'onehealthsouthsudan@gmail.com',
        'info.healthsecurity@gov.ss'
      ],
      description: 'We respond within 24 hours'
    },
    {
      icon: '🕒',
      title: 'Business Hours',
      details: [
        'Monday - Thursday: 8:00 AM - 5:00 PM',
        'Friday: 8:00 AM - 1:00 PM',
        'Weekend: Closed'
      ],
      description: 'Government working hours'
    }
  ];

  const departments = [
    {
      name: 'Health Security Unit',
      email: 'healthsecurity@gov.ss',
      phone: '+211 912 345 670'
    },
    {
      name: 'Surge Capacity Development',
      email: 'surgecapacity@gov.ss',
      phone: '+211 912 345 671'
    },
    {
      name: 'One Health Secretariat',
      email: 'onehealth@gov.ss',
      phone: '+211 912 345 672'
    },
    {
      name: 'Emergency Operations',
      email: 'emergencyops@gov.ss',
      phone: '+211 924 322 221'
    }
  ];

  return (
    <div className="contact-page" id='contact-page'>
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <h1>Contact Us</h1>
            <p className="page-subtitle">
              Get in touch with the Department of Health Security, Surge Capacity Development & One Health
            </p>
          </div>
        </div>
      </section>

      <section className="contact-methods">
        <div className="container">
          <div className="methods-grid">
            {contactMethods.map((method, index) => (
              <div key={index} className="method-card">
                <div className="method-icon">{method.icon}</div>
                <div className="method-content">
                  <h3>{method.title}</h3>
                  <p className="method-description">{method.description}</p>
                  <div className="method-details">
                    {method.details.map((detail, idx) => (
                      <div key={idx} className="detail-item">{detail}</div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="contact-main" id='email-us'>
        <div className="container">
          <div className="contact-layout">
            <div className="contact-form-section">
              <div className="form-header">
                <h2>Send us a Message</h2>
                <p>Fill out the form below and we'll get back to you as soon as possible</p>
              </div>

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter your email address"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="category">Inquiry Category</label>
                    <select
                      id="category"
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                    >
                      <option value="general">General Inquiry</option>
                      <option value="services">Services Information</option>
                      <option value="partnership">Partnership Opportunity</option>
                      <option value="emergency">Emergency Report</option>
                      <option value="feedback">Feedback & Suggestions</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Brief subject of your message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Please provide detailed information about your inquiry..."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner"></span>
                      Sending Message...
                    </>
                  ) : (
                    'Send Message'
                  )}
                </button>
              </form>
            </div>

            <div className="contact-sidebar">
              <div className="sidebar-section">
                <h3>Department Contacts</h3>
                <div className="department-list">
                  {departments.map((dept, index) => (
                    <div key={index} className="department-item">
                      <h4>{dept.name}</h4>
                      <div className="dept-contact">
                        <span>📧 {dept.email}</span>
                        <span>📞 {dept.phone}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="sidebar-section emergency-contact" id='emergency-contact'>
                <div className="emergency-icon">🚨</div>
                <div className="emergency-content">
                  <h3>Emergency Contact</h3>
                  <p>For urgent public health emergencies and outbreak reports</p>
                  <div className="emergency-number">+211 924 322 221 </div>
                  <small>Available 24/7 for emergencies only</small>
                </div>
              </div>

              <div className="sidebar-section feedback-section">
                <h3>Feedback & Complaints</h3>
                <p>We value your feedback to improve our services</p>
                <button className="feedback-btn">Submit Feedback</button>
              </div>

              <div className="sidebar-section social-section" id='social-section'>
                <h3>Follow Us</h3>
                <p>Stay connected through our social media channels</p>
                <div className="social-links">
                  <a href="#" className="social-link">📘 Facebook</a>
                  <a href="#" className="social-link">🐦 X</a>
                  <a href="#" className="social-link">📷 Instagram</a>
                  <a href="#" className="social-link">💼 LinkedIn</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section" id='map-section'>
        <div className="container">
          <div className="map-header">
            <h2>Our Location</h2>
            <p>Find us at the Ministry of Health Headquarters in Juba</p>
          </div>
          <div className="map-container">
            <div className="map-placeholder">
              <div className="map-overlay">
                <div className="location-info">
                  <h4>Ministry of Health Headquarters</h4>
                  <p>Ministries Complex Road, Mobil Round About</p>
                  <p>Juba, Central Equatoria State</p>
                  <p>South Sudan</p>
                  <button className="directions-btn">Get Directions</button>
                </div>
              </div>
              <div className="map-text">
                Interactive Map Would Be Embedded Here
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;